import React from 'react';
import { gridToWorld } from '../facilityCoords';
import { dashedRingPoints, ghostUprights } from '../buildingDetails';

const GHOST = '#5a8cff';
const UPRIGHT_H = 1.0;
const UPRIGHT_T = 0.04;

/**
 * Faint flat footprint for a ghost (future-facility) room. Non-interactive.
 * @param {object} roomDef - FACILITY_ROOMS entry (ghost:true)
 */
export function GhostFootprint({ roomDef }) {
  const { x, z, boxW, boxD } = gridToWorld(roomDef);
  const ringRadius = Math.max(boxW, boxD) * 0.55;
  const dashes = dashedRingPoints(ringRadius, 16);
  const uprights = ghostUprights(boxW, boxD);

  return (
    <group position={[x, 0, z]}>
      {/* Faint footprint slab */}
      <mesh position={[0, 0.03, 0]}>
        <boxGeometry args={[boxW, 0.05, boxD]} />
        <meshStandardMaterial color="#0d1015" transparent opacity={0.3} roughness={1} metalness={0} depthWrite={false} />
      </mesh>

      {/* Dashed selection ring */}
      {dashes.map((dash, i) => (
        <mesh
          key={`dash-${i}`}
          position={[dash.x, 0.06, dash.z]}
          rotation={[0, dash.rotationY, 0]}
        >
          <boxGeometry args={[dash.length, 0.03, 0.04]} />
          <meshStandardMaterial
            color={GHOST}
            emissive={GHOST}
            emissiveIntensity={0.15}
            transparent
            opacity={0.45}
            roughness={0.4}
            metalness={0.2}
            depthWrite={false}
          />
        </mesh>
      ))}

      {/* Holographic corner uprights */}
      {uprights.map(([dx, dz], i) => (
        <mesh key={`upright-${i}`} position={[dx, UPRIGHT_H / 2, dz]}>
          <boxGeometry args={[UPRIGHT_T, UPRIGHT_H, UPRIGHT_T]} />
          <meshStandardMaterial
            color={GHOST}
            emissive={GHOST}
            emissiveIntensity={0.1}
            transparent
            opacity={0.2}
            roughness={0.3}
            metalness={0.2}
            depthWrite={false}
          />
        </mesh>
      ))}
    </group>
  );
}
